import React, { useState } from 'react';

import Link from '@liquidweb-dev/undercurrent/Link';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import DialogCreateSupportCase, {
	createAssetLabel,
} from 'components/DialogCreateSupportCase';
import ArchiveIcon from '@liquidweb-dev/undercurrent/icons/lucide/Archive';
import Note from '@liquidweb-dev/undercurrent/Note';

/**
 * @param {object} props
 * @param {import('@liquidweb-dev/club-sauce/public/support/request/index.raw').LWApiPublicSupportRequestDetailsResultRawI['id']} props.id
 * @param {import('@liquidweb-dev/club-sauce/public/support/request/index.raw').LWApiPublicSupportRequestDetailsResultRawI['subject']} props.subject
 * @param {import('@liquidweb-dev/club-sauce/public/support/request/index.raw').LWApiPublicSupportRequestDetailsResultRawI['desired_lw_team']} props.desired_lw_team
 * @param {import('@liquidweb-dev/club-sauce/public/support/request/index.raw').LWApiPublicSupportRequestDetailsResultRawI['sub_type']} props.sub_type
 * @param {import('@liquidweb-dev/club-sauce/public/support/request/index.raw').LWApiPublicSupportRequestDetailsResultRawI['cc_list']} props.cc_list
 * @param {import('@liquidweb-dev/club-sauce/public/support/request/index.raw').LWApiPublicSupportRequestDetailsResultRawI['subaccntHashRef']} props.subaccntHashRef
 */
const NotRespondableBanner = ({
	id,
	subject,
	desired_lw_team: desiredLwTeam,
	sub_type: subType,
	cc_list: ccList,
	subaccntHashRef,
}) => {
	const [dialogIsOpen, setDialogOpen] = useState(false);

	return (
		<>
			<Note icon={<ArchiveIcon sx={{ flexShrink: 0 }} />}>
				<Typography component="span" variant="body-sm">
					It looks like this case is closed and archived. If you still need help
					with this issue,{' '}
				</Typography>
				<Link
					component="button"
					sx={{
						verticalAlign: 'baseline',
					}}
					onClick={() => setDialogOpen(true)}
				>
					<Typography variant="body-sm">open a new case</Typography>
				</Link>
				<Typography variant="body-sm">.</Typography>
			</Note>

			<DialogCreateSupportCase
				open={dialogIsOpen}
				relatedTicketId={id}
				initSubject={subject}
				initDepartment={desiredLwTeam}
				initCategory={subType}
				initAssetOption={
					subaccntHashRef?.uniq_id
						? {
								uniqId: subaccntHashRef?.uniq_id,
								label: createAssetLabel({
									domain: subaccntHashRef?.domain,
									type: subaccntHashRef?.type,
								}),
							}
						: undefined
				}
				initRecipients={ccList}
				onClose={() => setDialogOpen(false)}
			/>
		</>
	);
};

export default NotRespondableBanner;
